import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

function FitContent({ className, children }) {
  return (
    <div className="flex-grow relative border-none">
      <div
        className={cn(
          'absolute h-full w-full flex flex-col overflow-auto',
          className
        )}
      >
        {children}
      </div>
    </div>
  );
}

FitContent.defaultProps = {
  className: '',
  children: null,
};

FitContent.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.instanceOf(Object),
    PropTypes.string,
    PropTypes.number,
  ]),
};

export default FitContent;
